import React from 'react';
import PrintLayout from '../PrintLayout';

const S = {
  body: {
    position: 'absolute', top: 0, bottom: 68, left: 0, right: 0,
    background: '#ffffff', display: 'flex', flexDirection: 'column',
    justifyContent: 'center', padding: '0 13%',
  },
  eyebrow: {
    fontSize: 9, fontWeight: 700, letterSpacing: '2.5px', color: '#5f7942',
    textTransform: 'uppercase', marginBottom: 16, fontFamily: 'Montserrat, sans-serif',
  },
  title: {
    fontFamily: "'Playfair Display', Georgia, serif",
    fontSize: 46, fontWeight: 700, color: '#1e2e45', lineHeight: 1.12, marginBottom: 14, maxWidth: 760,
  },
  sub: { fontSize: 11, color: '#6b757e', lineHeight: 1.7, marginBottom: 26 },
  divider: { width: 36, height: 2, background: '#5f7942', marginBottom: 26, borderRadius: 1 },
  metaRow: { display: 'flex', gap: 56, marginBottom: 34 },
  metaLabel: {
    fontSize: 8.5, fontWeight: 700, letterSpacing: '1.5px', color: '#9aa2ab',
    textTransform: 'uppercase', marginBottom: 6, fontFamily: 'Montserrat, sans-serif',
  },
  metaValue: { fontSize: 13, fontWeight: 700, color: '#1e2e45' },
  quote: {
    maxWidth: 560, padding: '12px 16px', borderLeft: '2px solid #5f7942',
    fontSize: 12, fontStyle: 'italic', color: '#4a5568', lineHeight: 1.7,
  },
  quoteSource: { marginTop: 5, fontStyle: 'normal', fontWeight: 600, color: '#9aa2ab' },
};

export default function PrintCoverV2({ meeting }) {
  const rawDate = meeting.date || meeting.meetingDate || meeting.createdAt || null;
  const date = rawDate?.toDate
    ? rawDate.toDate().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
    : (typeof rawDate === 'string' ? rawDate : '');

  return (
    <PrintLayout pageNumber={1}>
      <div style={S.body}>
        <div style={S.eyebrow}>Meeting Assessment Report</div>
        <div style={S.title}>{meeting.name || meeting.title || meeting.teamName || 'Team Meeting'}</div>
        <div style={S.sub}>Based on the Death by Meeting framework by Patrick Lencioni</div>
        <div style={S.divider} />
        <div style={S.metaRow}>
          <div>
            <div style={S.metaLabel}>Team</div>
            <div style={S.metaValue}>{meeting.teamName || '—'}</div>
          </div>
          <div>
            <div style={S.metaLabel}>Date</div>
            <div style={S.metaValue}>{date || '—'}</div>
          </div>
          <div>
            <div style={S.metaLabel}>Consultant</div>
            <div style={S.metaValue}>{meeting.consultantName || '—'}</div>
          </div>
        </div>
        <div style={S.quote}>
          "There is simply no substitute for a good meeting—a dynamic, passionate, and focused engagement—when it comes to extracting the collective wisdom of a team."
          <div style={S.quoteSource}>— Patrick Lencioni, <i>Death by Meeting</i></div>
        </div>
      </div>
    </PrintLayout>
  );
}
